import React, { useState } from "react";
import { ReactComponent as Close } from "../../../../assets/images/teamclose.svg";
import Input from "../../../common/InputField";
import { useDispatch } from "react-redux";
import { updateTicket } from "../../../../store/features/updateTicket";
import { getTicketMessagesById } from "../../../../store/features/getTicketMessagesById";
import { emailPattern } from "../../../../utils";
import { toast } from "react-toastify";

function ChangeRequesterPopup({
  setOpen,
  ticketId,
  currentName = "",
  currentEmail = "",
  onAssignSuccess,
}) {
  const dispatch = useDispatch();
  const [email, setEmail] = useState(currentEmail);
  const [name, setName] = useState(currentName);
  const [loading, setLoading] = useState(false);


  const isEmailValid = emailPattern.test(email.trim());
  const isNameValid = name.trim() !== "";
  const isUnchanged =
    name.trim() === currentName.trim() && email.trim() === currentEmail.trim();

  const validateForm = () => {
    if (!email.trim() || !name.trim()) {
      toast.error("Both fields are required.");
      return false;
    }
    if (name.length > 50) {
      toast.error("Name cannot exceed 50 characters.");
      return false;
    }
    if (email.length > 100) {
      toast.error("Email cannot exceed 100 characters.");
      return false;
    }
    if (!isEmailValid) {
      toast.error("Please enter a valid email address.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    try {
      await dispatch(
        updateTicket({
          ticketId,
          updateData: {
            customerName: name,
            customerEmail: email,
          },
        })
      ).unwrap();
      await dispatch(getTicketMessagesById(ticketId)).unwrap();
      if (onAssignSuccess) {
        onAssignSuccess();
        toast.success("Requester updated successfully!");
      }

      setOpen(false);
    } catch (err) {
      toast.error("Failed to update requester.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="overlay" />
      <div className="Team-PopUp-Container" style={{maxWidth: "424px"}}>
        <div className="Team-PopUp-Header">
          <p className="PopUp-Text01">Change Requester</p>
          <p className="PopUp-Text02" onClick={() => setOpen(false)}>
            <Close />
          </p>
        </div>
      
        <form className="PopUp-Email-Container" onSubmit={handleSubmit}>
          <Input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            title="Name"
            placeholder="Enter customer name"
            style={{minWidth:'360px'}}
          />
          <br />
          <Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            title="Email"
            placeholder="Enter email address"
            style={{minWidth:'360px'}}

          />
          <div className="Ticket-Button-Container">
            <button
              className="buttonstyle-Cancel"
              type="button"
              onClick={() => setOpen(false)}
            >
              Cancel
            </button>
            <button
              className="buttonstyle-Ticket"
              type="submit"
              style={
                (!isEmailValid || isUnchanged || !isNameValid)
                  ? { cursor: "not-allowed" }
                  : {}
              }
              disabled={loading || isUnchanged || !isEmailValid || !isNameValid}
            >
              {loading ? "Updating..." : "Update"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default ChangeRequesterPopup;